// extracted by mini-css-extract-plugin
export default {"layoutRoot":"layout_layoutRoot__NXZGd","blockWrapper":"layout_blockWrapper__XEv2f"};